import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { IndexPage } from "./pages/IndexPage/IndexPage";
import { PortalFooterHomePage } from "./UIComponents/Footer/PortalFooterHomePage";
import { PortalHeader } from "./UIComponents/Header/PortalHeader";
import { PortalSideBar } from "./UIComponents/PortalSideBar/PortalSideBar";
import { Spinner } from "../../core/components/Spinner";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import "./HomePortal.css";
import "./Portal.css";
import { usePortal } from "./hook/usePortalState";
import { configPortal } from "../../configPortal";

interface Props {
  setIsLogged: any;
  notFound: boolean;
}

const MOBILE_BREAKPOINT = 990.40; 
const MENU_BREAKPOINT = 770;

const computeMatches = (maxWidth: number) => {
  if (typeof window === "undefined") return false;

  if (typeof window.matchMedia === "function") {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  }

  const vw = window.visualViewport?.width ?? window.innerWidth;
  return vw <= maxWidth;
};

export const HomePortal = ({ setIsLogged }: Props) => {
  const { page, param, recurso }: any = useParams();
  const { viewMenu, setIsMovil, setViewMenu } = usePortal();

  useEffect(() => {
    const primaryColor = configPortal.PRIMARY_COLOR_APP || "#ca4e07";
    document.documentElement.style.setProperty("--primary-color", primaryColor);
  }, []);

  useEffect(() => {
    const syncLayout = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      _single.setWindowSize(w, h);

      const mobileView = computeMatches(MOBILE_BREAKPOINT);
      setIsMovil(mobileView);

      // Menú: si pantalla >= 770, forzamos abierto
      const isSmallMenu = computeMatches(MENU_BREAKPOINT); // true si <= 770
      if (!isSmallMenu) setViewMenu(true);
    };

    syncLayout();

    window.addEventListener("resize", syncLayout);
    window.visualViewport?.addEventListener("resize", syncLayout);

    return () => {
      window.removeEventListener("resize", syncLayout);
      window.visualViewport?.removeEventListener("resize", syncLayout);
    };
  }, [setIsMovil, setViewMenu]);

  const handleMainClick = () => {
    const isSmallMenu = computeMatches(MENU_BREAKPOINT);
    if (isSmallMenu && viewMenu) setViewMenu(false);
  };

  return (
    <>
      <Spinner />
      <div className="home-portal">
        <div className={`home-portal-sidebar ${viewMenu ? "active" : "hidden"}`}>
          <PortalSideBar setIsLogged={setIsLogged} />
        </div>

        <div className="home-portal-main" onClick={handleMainClick}>
          <PortalHeader setIsLogged={setIsLogged} />
          <div className="home-portal-content">
            <IndexPage urlElement={{ page, parametro: param, atributo: recurso }} />
          </div>
          <PortalFooterHomePage />
        </div>
      </div>
    </>
  );
};
